import ThoughtBubble from './ThoughtBubbleClass';

export default ThoughtBubble;
